<template>
	<v-icon
		large
		v-bind="$attrs"
		:class="{'invert': !icon.startsWith('mdi-')}"
	>
		{{ icon }}
	</v-icon>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue'
import { IEvento } from '../../common/types/Evento'

const props = defineProps({
	evento: { type: Object as PropType<IEvento>, required: true },
})

const iconMap: {[key: string]: any} = {
	['Ordinária - Instrução']: '$vuetify.icons.teacher',
	['Ordinária - Outras']: '$vuetify.icons.conversation',
	['Ordinária - J. Ritualístico']: '$vuetify.icons.dish',
	['Ordinária - Finanças']: '$vuetify.icons.money',
	['Magna - Iniciação']: 'mdi-chess-king',
	['Magna - Elevação']: 'mdi-chess-king',
	['Magna - Exaltação']: 'mdi-chess-king',
	['Magna - Instalação']: 'mdi-chess-king',
	['Magna - Outras']: 'mdi-chess-king',
	['Extraordinária']: '$vuetify.icons.hand',
	['Pública']: '$vuetify.icons.value',
	['EVENTO']: '$vuetify.icons.dinner',
	['Evento']: '$vuetify.icons.value',
}

const icon = computed((): string => iconMap[props.evento.tipoDaSessao.nome] || '')
</script>

<style scoped>

.invert { filter: invert(100%); }

</style>
